export enum OneVerifyIntegrationStatus {
    comingSoon = "coming_soon",
    live = "live",
}

export enum OneVerifyIntegrationCategory {
    eraData = "era_data",
    ehr = "ehr",
}

// Integrations page support email — notify, setup, or new integration request.
export enum OneVerifyIntegrationSupportRequestType {
    notifyMe = "notify_me",
    setup = "setup",
    newIntegrationRequest = "new_integration_request",
    requestEraCsvAccess = "request_era_csv_access",
}
